import React from "react";

export default function ProductInfoStrip({ product }) {
  const rows = [
    { label: "Material", value: product.material },
    { label: "Care Instructions", value: product.care },
    { label: "Shipping", value: product.shipping },
    { label: "Returns", value: product.returns }
  ];

  return (
    <div className="container">
      <div className="product-info-strip">
        {rows.map((r) => (
          <div key={r.label}>
            <div className="product-info-label">{r.label}</div>
            <div className="product-info-value">{r.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
